type EnvVarKey = keyof ImportMetaEnv;

const readEnv = (key: EnvVarKey, fallback?: string) => {
  const value = import.meta.env[key];

  if (value === undefined || value === "") {
    if (fallback !== undefined) {
      return fallback;
    }

    if (import.meta.env.DEV) {
      console.warn(
        `[env] Missing value for ${key}. Please define it in your environment variables.`
      );
    }

    return "";
  }

  return value;
};

const parseNumber = (value: string, fallback: number) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const env = {
  apiUrl: readEnv("VITE_API_URL"),
  apiTimeout: parseNumber(readEnv("VITE_API_TIMEOUT", "10000"), 10000),
};
